@if (showBreadCrumbs) {
  <app-bread-crumbs
    class="position-relative"
    style="z-index: 1;"
    [(breadcrumbs)]="breadcrumbs"
  ></app-bread-crumbs>
}

@if ((showDetailed || expanded) && article) {
  <div
    [class.container]="!fromTableView"
    [class.container-fluid]="fromTableView"
    class="px-3 mb-3 px-md-2 px-lg-3 px-xl-2" [ngClass]="article?.setitem ? 'setitem' : ''"
    >
    <div class="pt-0 row p-md-2 p-xl-0">
      <div
        class="px-3 pt-0 col-md-12 col-lg-6 col-xl-6 d-sm-block ps-md-2 ps-lg-2 ps-xl-2 position-relative"
        >
        @if (article.description) {
          <h1
            [innerHTML]="article.description"
            [ngClass]="article.description.length > 30 ? 'longDesc' : ''"
            class="pt-0 mt-0 mb-0 articleHeader pt-mb-2 d-block d-sm-none mt-sm-1"
          ></h1>
        }
        @if (article.description) {
          <h2
        [innerHTML]="
          (article.caption ? article.caption : '') +
          ' ' +
          (article.season && (!['ANL'].includes(applicationService.getSelectCompanyGroupCode() || framenumber))
            ? article.season
            : '')
        "
            class="pt-0 mb-2 articleHeader subHeader d-block d-sm-none"
          ></h2>
        }
        <h4 class="mb-2 articleHeader">
          @if (article && article.base_collection && !article.top_performer) {
            <app-focus-model
            ></app-focus-model>
          }
        </h4>
         @if (
            article.top_performer && article.single_article_code
            ) {
              <app-highlight-badge
                @topPerformerAnimation
                [article]="article"
                class="top-performer relative position-relative d-block"
                style="z-index: 99;"
                >
              </app-highlight-badge>
          }
        <div
          #carouselInner
          [class.carousel-pinned]="carouselFixed && fromTableView"
          [style.width.px]="carouselFixed && fromTableView ? carouselFixedWidth : null"
          [style.left.px]="carouselFixed && fromTableView ? carouselFixedLeft : null"
        >
          @if (
            ((!article.parsedImages && placeholder) || article.no_img) &&
            !articleNotFound
            ) {
            <div
              class="articlePreImg d-inline-flex justify-content-center h-100 w-100 mt-4"
              [style.background-image]="'url(' + placeholder + ')'"
              [@enterAnimation]
              style="min-height: 280px"
              >
              @if (loading) {
                <span
                  class="spinner-border spinner-border"
                  role="status"
                  aria-hidden="true"
                ></span>
              }
            </div>
          }
          <!-- Article carousel -->
          @if (
            article.parsedImages && showCarousel && !article.no_img && !show360
            ) {
            <app-article-image-carousel
              #carouselContainer
              [@enterAnimation]
              class="d-flex px-sm-5"
              [height]="article.setitem ? '500px' : '50vh'"
              [(articleImages)]="article.parsedImages"
              [initialImage]="article.z_img[0]"
          [title]="
            article.description + ' ' + (article.caption ? article.caption : '')
          "
              >
            </app-article-image-carousel>
          }
          @if (article.img3d?.length) {
            <app-three-dee-viewer
              [id]="'threedeeviewer'"
              [article]="article"
              class="d-flex h-100"
              style="right: 0; top: 0;"
              [ngClass]="{ 'position-absolute': !show360 }"
              [src]="article.img3d[0]"
              (show360)="show360 = $event"
            ></app-three-dee-viewer>
          }
        </div>
        <div [style.height.px]="carouselFixed && fromTableView ? carouselPlaceholderHeight : 0"></div>
        @if (articleNotFound) {
          <div class="text-center">
            <h1>{{ "ARTICLE_NOT_FOUND" | translate }}</h1>
            <img
              class="w-100"
              src="./assets/images/accident.svg"
              alt="accident"
              style="max-height: 30vh"
              />
          </div>
        }
        <app-disclaimer
          [companyGroups]="['WG', 'GHO','LAP']"
          [text]="applicationService.getSelectCompanyGroupCode() == 'LAP' ? ('DISCLAIMER_IMAGES_LAP' | translate) :('DISCLAIMER_IMAGES' | translate)"
          [class]="'d-block mt-2 mx-2 px-1'"
        ></app-disclaimer>
      </div>
      <div
        class="pb-0 col-md-12 col-lg-6 col-xl-6 h-100 articleBasics mt-3 mt-sm-0"  [class.from-table-view]="fromTableView">
        @if (article.description) {
          <h1
            [innerHTML]="article.description"
            [ngClass]="article.description.length > 30 ? 'longDesc' : ''"
            class="pt-0 px-2 mb-0 articleHeader pt-mb-2 d-none d-sm-block"
          ></h1>
        }
        @if (article.description) {
          <h2
            [@enterAnimation]
        [innerHTML]="
          (article.caption ? article.caption : '') +
          ' ' +
          (article.season &&
          (!['ANL'].includes(applicationService.getSelectCompanyGroupCode()) || framenumber)
            ? article.season
            : '')
        "
            class="pt-0 px-2 mb-2 articleHeader subHeader d-none d-sm-block"
          ></h2>
        }
        <div
          class="textContainer customScrollbar mt-sm-4 px-2"
          [ngClass]="!article.has_replacement ? 'maxHeight' : ''"
          >
          @if (!article.has_replacement) {
            <p
              [innerHTML]="article.text ? article.text : ''"
              class="mb-0"
              [@enterAnimation]
            ></p>
          }
          @if (article.has_replacement && article.replacement_article) {
            <app-replacement-article
              [articleCode]="article.replacement_article['article_code']"
            ></app-replacement-article>
          }
          @if (article.usps) {
            <div [innerHTML]="article.usps ? article.usps : ''" [@enterAnimation]></div>
          }
          @if (!article.season && article.brand) {
            <b>{{ article.brand }}</b>
          }
          <p
          [style.visibility]="
            article.single_article_code ? 'visible' : 'hidden'
          "
            >
            {{ "ARTICLE_NO" | translate }}: {{ article.single_article_code }}
            <br />
            @if (article.single_article_code_short && article.single_article_code !== article.single_article_code_short) {
              {{ "SECONDARY_ARTICLENR" | translate }}:
              {{ article.single_article_code_short }}<br
              />
          }
          @if (article.single_ean) {
            {{ "EANCODE" | translate }}: {{ article.single_ean }}
          }
          @if (article.supplier_code) {
            <br />{{ "SUPPLIER_CODE" | translate }}:
            {{ article.supplier_code }}
          }
          @if (article.store_packaging) {
            <br />{{article.store_packaging.description}}:
            {{article.store_packaging.value|translate}}
          }
        </p>
        @if (hasDealerSupportArticles && article.mandatory_battery) {
          <p
            class="border border-warning statusIcon status status_3"
            >
            {{ "CALL_DEALERSUPPORT" | translate }}
          </p>
        }
        @if (article.preorder && !preOrder && preorderEnabledForArticleType && !article.temporarily_undeliverable && !modelTemporarilyUndeliverable) {
          <p
            class="btn btn-success rounded managePreorderForArticle px-2 clickable withOpacity"
            (click)="openPreorderModal()"
            >
            {{ "ARTICLE_HAS_PREORDER" | translate }}
          </p>
        }
        <ng-content></ng-content>
      </div>
      <div
        class="addContainer w-100"
        [style.display]="articleNotFound  ? 'none' : ''"
        >
        <div class="px-2">
         
          <!-- Article matrix -->
          <div class="mb-3 d-flex align-items-center">
            <i class="info info-1 material-icons" *ngIf="showOrBeforeOption" [ngbTooltip]=" 'PREFERRED_WEEK_SELECT_CLICK_ORDER_EXPLANATION' | translate"
              [autoClose]="false">info</i>
            @if (article.matrix) {
              @if (
                (article.matrix && article.matrix.options.length > 1) ||
                (article.matrix &&
                article.matrix.options.length === 1 &&
                article.matrix.options[0].value.length > 1)) {
                <app-matrix
                  [article]="article"
              (articleSelected)="
                selectArticle($event);
              "
                ></app-matrix>
              } @else {
                @if (article.temporarily_undeliverable || modelTemporarilyUndeliverable) {
                  <span class="d-block text-danger w-100">
                    {{"TEMPORARILY_UNDELIVERABLE"|translate}}
                  </span>
                }
                @if (
                  article.stock_status <= 7 &&
                  (!article.matrix || article.matrix.options.length <= 1) && !modelTemporarilyUndeliverable
                  ) {
                  <app-stock-status
                    [showText]="true"
                    [article]="article"
                  ></app-stock-status>
                }
              }
            }
          </div>
          <!-- Article prices -->
          <div class="priceContainer">
             
            @if (article.retail_price) {
              <h5 class="mb-0">
                <app-retail-price
                  [price]="article.retail_price"
                  [showLabel]="true"
                ></app-retail-price>
              </h5>
            }
            @if (article.gross_price) {
              <h4 class="mb-0 d-block">
                <app-gross-price
                  [price]="article.gross_price"
                  class="opacity-75"
                  [showLabel]="true"
                ></app-gross-price>
              </h4>
            }
            @if (article.lease_start_price) {
              <h5 class="mb-2 d-block">
                @if (
                  article.lease_start_price && article.lease_start_price.value && article.is_lease
                  ) {
                  <app-lease-price
                    class="opacity-75"
                    [showTable]="!article.has_flex_batt"
                    [lowestPrice]="article.lease_start_price"
                    [articleCode]="article.single_article_code"
                    [leasePrices]="article.lease_price"
                  ></app-lease-price>
                }
              </h5>
            }
            @if (article.net_price) {
              <h3
                class="mb-4 mb-md-3 mt-1"
                >
                <app-nett-price
                  [price]="article.net_price"
                  [showLabel]="true"
                  [hasDifferentPrices]="article.has_different_prices"
                  [volumePrices]="article.volume_price"
                  [article]="article"
                ></app-nett-price>
              </h3>
            }
            @if (article.volume_price) {
              <div class="d-inline-block">
                <app-volume-prices
                  [headerLeft]="'QUANTITY'"
                  [headerRight]="'PRICE'"
                  [popoverTitle]="'VOLUME_PRICES'"
                  [price]="article.volume_price"
                  [regularPrice]="article.net_price"
                ></app-volume-prices>
              </div>
            }
          </div>
          @if (
            article.promotion ||
            article.new ||
            article.setitem ||
            article.mandatory_battery ||
            article.is_msl ||
            article.is_lease || article.collection_status
            ) {
              <app-highlight-badge
                [article]="article"
                class="relative d-block"
                >
              </app-highlight-badge>
          }
        </div>
        <div class="row addButtonContainer">
          <div class="col-md-6 col-lg-12 col-xl-8 col-sm-6 col-xs-6 centerContainer ps-sm-4" [style.display]="preOrder ? 'none' : ''">
            @if (!article.setitem && !selectForWarrantyMode) {
              <app-add-to-basket-button
                [article]="article"
                [modelTemporarilyUndeliverable]="modelTemporarilyUndeliverable"
                class="d-inline-block"
                [ngClass]="article.bom ? 'hasBom' : ''"
                >
                @if (article.bom && showBom) {
                  <button
                    class="ms-1 me-0 btn btn-dark btn-lg me-md-0 ms-sm-0"
                    pRipple
                    (click)="links.showBom($event)"
                    >
                    {{ "BOM" | translate }}
                  </button>
                }
                @if (article.is_lease && article.article_type === 'F') {
                  <app-add-to-lease-button
                    class="ms-2 d-block"
                    [article]="article"
                    [fromLeaseRequest]="leaseRequest"
                    [disabled]="!article.single_article_code"
                  ></app-add-to-lease-button>
                }
              </app-add-to-basket-button>
            }
            @if (selectForWarrantyMode) {
              <app-select-for-warranty-button
                [article]="article"
                [bomQuantity]="bomQuantity"
                >
              </app-select-for-warranty-button>
            }
          </div>
          <div
            class="d-xl-flex align-items-xl-center"
            [class]="!preOrder ? 'px-0 col-md-6 col-lg-12 col-xl-4 col-sm-6 col-xs-6 centerContainer mt-2 mt-sm-0 ps-3' : 'col-12'"
            [class.justify-content-xl-end]="!preOrder"
            [hidden]="hideLinks"
            >
            <!-- Article links -->
            <app-article-links
              #links
              class="d-flex mt-0 me-2 mt-sm-4 mt-md-3 mt-xl-0"
              [class.w-100]="preOrder"
              [article]="article"
              [hidden]="article.stock_status === 7"
              [preorder]="preOrder"
              [articleDetails]="true"
            ></app-article-links>
          </div>
        </div>
        <app-article-specifications
          *ngIf="fromTableView"
          #specifications
          [showDetailed]="showDetailed || expanded"
          [specifications]="article.parsedSpecs"
          [ngClass]="
            specifications?.specsCollapsed ? 'collapsed' : specsCollapsable ? 'expanded' : ''
          "
          [companyId]="article.company_id"
          [specsCollapsed]="specifications?.specsCollapsed"
        ></app-article-specifications>
      </div>
    </div>
  </div>
</div>
}

@if ((showDetailed || expanded) && article) {
  <div class="other-details mt-5" id="other-details">
    <div [class.container]="!fromTableView" [class.container-fluid]="fromTableView">
      <div class="px-0 col-md-12">
        <app-set-items
          [article]="article"
          [showDetailed]="true"
          [companyId]="article.company_id"
          class="mt-2 w-100 d-block"
          >
        </app-set-items>
      </div>
      <div class="row">
        @if (
          article.alternative_ecommerce ||
          article.cross_sell_ecommerce ||
          article.up_sell_ecommerce ||
          article.has_flex_batt
          ) {
          <div
            class="col-md-12 col-lg-6 col-sm-12"
            >
            <!-- E-commerce -->
            <ul class="mb-0 border-0 nav nav-pills my-md-4 mb-md-2">
              @if (article.alternative_ecommerce) {
                <li class="nav-item">
                  <h3
                    class="mb-0 clickable withOpacity"
                    (click)="selectedEcommerceTab = 'alternatives'"
              [ngClass]="
                selectedEcommerceTab === 'alternatives' ? 'active' : ''
              "
                    >
                    {{ "ALTERNATIVES" | translate }}
                  </h3>
                </li>
              }
              @if (article.cross_sell_ecommerce || article.has_flex_batt) {
                <li
                  class="nav-item"
                  >
                  <h3
                    class="mb-0 clickable withOpacity"
                    (click)="selectedEcommerceTab = 'crosssell'"
                    [ngClass]="[selectedEcommerceTab === 'crosssell' ? 'active' : '']"
                    >
                    {{ "CROSS_SELL_HEADER" | translate }}
                  </h3>
                </li>
              }
            </ul>
            @if (
              article.alternative_ecommerce &&
              selectedEcommerceTab === 'alternatives'
              ) {
              <div
                >
                <app-ecommerce-articles
                  #alternatives
                  [mainArticle]="article"
                  [type]="'alternatives'"
                  [header]="'ALTERNATIVES' | translate"
                  [showHeader]="false"
                  [shopOption]="false"
                ></app-ecommerce-articles>
              </div>
            }
            @if (
              ((article.cross_sell_ecommerce || article.has_flex_batt) &&
              selectedEcommerceTab === 'crosssell') ||
              (!article.alternative_ecommerce &&
              (article.cross_sell_ecommerce || article.has_flex_batt))
              ) {
              <div
                >
                <app-ecommerce-articles
                  [mainArticle]="article"
                  [type]="'crosssell'"
                  [header]="'CROSS_SELL' | translate"
                  [showHeader]="false"
                  [shopOption]="false"
                  (hasDealerSupportArticles)="hasDealerSupportArticles = $event"
                ></app-ecommerce-articles>
              </div>
            }
            @if (
              (article.up_sell_ecommerce)
              ) {
              <div
                ><h3
                class="mb-0 clickable withOpacity"
                (click)="selectedEcommerceTab = 'upsell'"
                [ngClass]="[selectedEcommerceTab === 'upsell' ? 'active' : '']"
                >
                {{ "UPSELL_SELL_HEADER" | translate }}
              </h3>
              <app-ecommerce-articles
                [mainArticle]="article"
                [type]="'upsell'"
                [header]="'UP_SELL' | translate"
                [showHeader]="false"
                [shopOption]="false"
              ></app-ecommerce-articles>
            </div>
          }
        </div>
      }
      <div
        class="col-md-12 col-sm-12"
        [ngClass]="
          article.alternative_ecommerce ||
          article.cross_sell_ecommerce ||
          article.has_flex_batt
            ? 'col-md-6 col-lg-6 '
            : 'col-md-12 col-lg-12'
        "
        >
        @if (article.parsedSpecs && article.parsedSpecs.length && !fromTableView) {
          <h3
            class="pt-4 ps-1"
            >
            {{ "SPECIFICATIONS" | translate }}
          </h3>
        }
        <div class="row mx-0">
          <app-article-specifications
            class="w-100 d-block ps-1"
            *ngIf="!fromTableView"
            #specifications
            [showDetailed]="showDetailed || expanded"
            [specifications]="article.parsedSpecs"
            [ngClass]="
              specifications?.specsCollapsed ? 'collapsed' : specsCollapsable ? 'expanded' : ''
            "
            [companyId]="article.company_id"
            [specsCollapsed]="specifications?.specsCollapsed"
          ></app-article-specifications>
        </div>
      </div>
      @if (article.model_code && specificationsComponent) {
        <app-cms-page-content
          [pageId]="'article-information-' + (article.model_code | lowercase) + '?folder=companyPage/article-data'"
          [showNotFound]="false"
          (contentLoaded)="onSpecsContentLoaded($event)"
        ></app-cms-page-content>
      }
    </div>
    @if (!preOrder && !standAlone) {
      <div class="d-flex flex-column gap-5 mt-5">
        <app-recommendations-preview></app-recommendations-preview>
        <app-recently-viewed
          id="recentlyViewed"
          #recentlyViewed
          [hidden]="!showRecent || loading"
          [companyGroupCode]="applicationService.getSelectCompanyGroupCode()"
          [maxItems]="4"
          [parent]="'pdp'"
          style="margin-bottom: 120px"
        ></app-recently-viewed>
      </div>
    }
  </div>
</div>
}
<!--Compact view for treeview -->
@if (!showDetailed && !expanded) {
  <div
    class="container-compact compact customScrollbar"
    >
    <div class="ps-4 pb-4 row w-100">
      <div class="ps-0 col-md-12 d-sm-block">
        <h1
          [innerHTML]="article.description"
          class="mb-0 articleHeader"
          (click)="gotoItem(article, $event)"
        ></h1>
        <h2
        [innerHTML]="
          (article.caption ? article.caption : '') +
          ' ' +
          (article.single_article_code ? article.single_article_code : '') +
          (article.single_ean ? ' | ' + article.single_ean : '')
        "
          (click)="gotoItem(article, $event)"
        ></h2>
        @if (article.stock_status < 5 || article.setitem || article.is_lease || article.top_performer) {
          <app-highlight-badge
              @topPerformerAnimation
              [article]="article"
              class="relative position-relative d-block"
              style="z-index: 99;"
            (click)="gotoItem(article, $event)"
          ></app-highlight-badge>
        }
        <h4 class="mb-2 articleHeader">
          @if (article.base_collection) {
            <app-focus-model></app-focus-model>
          }
        </h4>
        @if ((!article.parsedImages && placeholder) || article.no_img) {
          <div
            class="text-center w-100 imgContainer"
            >
            @if (article.thumbs && article.thumbs.length) {
              <img
                [src]="article.thumbs[0]"
                class="img-responsive"
                />
            }
          </div>
        }
        @if (article.parsedImages && showCarousel && !article.no_img) {
          <app-article-image-carousel
            #carouselContainer
            [height]="'240px'"
            [(articleImages)]="article.parsedImages"
        [title]="
          article.description + ' ' + (article.caption ? article.caption : '')
        "
          ></app-article-image-carousel>
        }
      </div>
      <div class="ps-0 col-md-12">
        <div class="my-3">
          <div class="mb-3">
            @if (article.matrix) {
              @if (article.matrix && article.matrix.options.length) {
                <app-matrix
                  [article]="article"
                  (articleSelected)="selectArticle($event)"
                ></app-matrix>
              }
            }
            @if (
              (article.matrix &&
              (!article.matrix.options.length ||
              article.matrix.options.length === 1)) ||
              !article.matrix
              ) {
              <app-inline-matrix
                [article]="article"
                >
              </app-inline-matrix>
            }
          </div>
          @if (article.retail_price) {
            <h5>
              <app-retail-price
                [price]="article.retail_price"
                [showLabel]="true"
              ></app-retail-price>
            </h5>
          }
          @if (article.gross_price) {
            <h4 class="mb-0 d-block">
              <app-gross-price
                [price]="article.gross_price"
                [showLabel]="true"
              ></app-gross-price>
            </h4>
          }
          @if (article.lease_start_price) {
            <h4 class="my-2 d-block">
              @if (article.lease_start_price && article.lease_start_price.value && article.is_lease) {
                <app-lease-price
                  [showTable]="!article.has_flex_batt"
                  [lowestPrice]="article.lease_start_price"
                  [articleCode]="article.single_article_code"
                  [leasePrices]="article.lease_price"
                ></app-lease-price>
              }
            </h4>
          }
          @if (article.net_price) {
            <h3
              >
              <app-nett-price
                [price]="article.net_price"
                [showLabel]="true"
                [hasDifferentPrices]="article.has_different_prices"
                [volumePrices]="article.volume_price"
                [article]="article"
              ></app-nett-price>
            </h3>
          }
          @if (article.volume_price && article.volume_price) {
            <div
              class="d-inline-block"
              >
              <app-volume-prices
                [headerLeft]="'QUANTITY'"
                [headerRight]="'PRICE'"
                [popoverTitle]="'VOLUME_PRICES'"
                [price]="article.volume_price"
                [regularPrice]="article.net_price"
              ></app-volume-prices>
            </div>
          }
          @if (!article.setitem && !selectForWarrantyMode) {
            <app-add-to-basket-button
              [article]="article"
              class="mt-2 d-block"
              >
              @if (article.bom && showBom) {
                <button
                  class="btn btn-dark mt-lg-1 mt-xl-0" pRipple
                  (click)="links.showBom($event)"
                  >
                  {{ "BOM" | translate }}
                </button>
              }
              @if (article.is_lease && article.article_type === 'F') {
                <app-add-to-lease-button
                  class="d-flex"
                  [btnClass]="' ms-2 mt-lg-1 mt-xl-0'"
                  [article]="article"
                  [fromLeaseRequest]="leaseRequest"
                  [disabled]="!article.single_article_code"
                ></app-add-to-lease-button>
              }
            </app-add-to-basket-button>
          }
          @if (selectForWarrantyMode) {
            <app-select-for-warranty-button
              [article]="article"
              [bomQuantity]="bomQuantity"
              >
            </app-select-for-warranty-button>
          }
        </div>
        <p
          (click)="textCollapsed = !textCollapsed"
          [innerHTML]="article.text ? article.text : ''"
        ></p>
        @if (article.has_replacement && article.replacement_article) {
          <app-replacement-article
            [articleCode]="article.replacement_article['article_code']"
          ></app-replacement-article>
        }
        <div [innerHTML]="article.usps ? article.usps : ''"></div>
      </div>
      <div class="px-0 col-md-12">
        @if (article.single_article_code && showDetailed) {
          <app-set-items
            [article]="article"
            [showDetailed]="false"
            [companyId]="article.company_id"
            class="mt-2 w-100 d-block"
          ></app-set-items>
        }
      </div>
      <div class="px-3 row">
        <app-article-specifications
          [showDetailed]="showDetailed"
          [specifications]="article.parsedSpecs"
          >
        </app-article-specifications>
        <div class="col-md-12">
          <app-article-links
            #links
            class="float-left mt-2"
            [article]="article"
            [hidden]="article.stock_status === 7"
          ></app-article-links>
        </div>
      </div>
    </div>
  </div>
}
